import { render, staticRenderFns } from "./ManualsIntegration.vue?vue&type=template&id=33b830d8&"
import script from "./ManualsIntegration.vue?vue&type=script&lang=js&"
export * from "./ManualsIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports